import {
  Box,
  Button,
  TextField,
  Select,
  MenuItem,
  Autocomplete,
  InputLabel,
  CircularProgress,
} from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  generateAndExecuteMutation,
  generateMutation,
  graphqlMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";
import {
  caseManagementUrl,
  clientManagementUrl,
  setupManagementUrl,
} from "../../../config";
import {
  allCorporateClients,
  allIndividualClients,
  caseCategory,
} from "../../../data/Axios/queries";
import { fetchDataEngine } from "../../../data/Axios/DynamicService";
import { useState } from "react";
import Header from "../../../components/Header";

const base_url = clientManagementUrl.uri;

const CorporateClientsForm = (props) => {
  const initialValues = {
    id: props.data ? props.data.id : null,
    companyName: props.data ? props.data.companyName : null,
    contactNumber: props.data ? props.data.contactNumber : null,
    email: props.data ? props.data.email : null,
    address: props.data ? props.data.address : null,
    industrySector: props.data ? props.data.industrySector : null,
    createdDate: props.data ? props.data.createdDate : null,
    createdBy: props.data ? props.data.createdBy : null,
    updatedBy: props.data ? props.data.updatedBy : null,
    updatedDate: props.data ? props.data.updatedDate : null,
    isActive: props.data ? props.data.isActive : 1,
    statusFlag: props.data ? props.data.statusFlag : null,
    registrationNumber: props.data ? props.data.registrationNumber : null,
    incorporationDate: props.data ? props.data.incorporationDate : null,
    legalStructure: props.data ? props.data.legalStructure : null,
    countryOfIncorporation: props.data
      ? props.data.countryOfIncorporation
      : null,
    taxIdentificationNumber: props.data
      ? props.data.taxIdentificationNumber
      : null,
    authorizedSignatoryName: props.data
      ? props.data.authorizedSignatoryName
      : null,
    authorizedSignatoryPosition: props.data
      ? props.data.authorizedSignatoryPosition
      : null,
    authorizedSignatoryEmail: props.data
      ? props.data.authorizedSignatoryEmail
      : null,
    authorizedSignatoryPhone: props.data
      ? props.data.authorizedSignatoryPhone
      : null,
    companyAddress: props.data ? props.data.companyAddress : null,
    billingAddress: props.data ? props.data.billingAddress : null,
    contactPersonName: props.data ? props.data.contactPersonName : null,
    contactPersonPosition: props.data ? props.data.contactPersonPosition : null,
    contactPersonEmail: props.data ? props.data.contactPersonEmail : null,
    contactPersonPhone: props.data ? props.data.contactPersonPhone : null,
    companyId: props.data ? props.data.companyId : null,
    company: props.data ? props.data.company : null,
  };

  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);

  const validationSchema = yup.object().shape({
    companyName: yup.string().required("Company Name is required").nullable(),
    contactNumber: yup
      .string()
      .matches(/^(0[17]\d{8}|\+254\d{9})$/, "Enter a valid contact number")
      .required("Contact Number is required")
      .nullable(),
    email: yup
      .string()
      .email("Enter a valid email address")
      .required("Email is required")
      .nullable(),
    address: yup.string().required("Address is required").nullable(),
    industrySector: yup.string().required("Industry Sector is required").nullable(),
    taxIdentificationNumber: yup
      .string()
      .matches(/^[A-Z]\d{9}[A-Z]$/, "Enter a valid KRA PIN")
      .required("KRA PIN is required")
      .nullable(),
    authorizedSignatoryPhone: yup
      .string()
      .matches(/^(0[17]\d{8}|\+254\d{9})$/, "Enter a valid phone number", { excludeEmptyString: true })
      .nullable(),
    contactPersonPhone: yup
      .string()
      .matches(/^(0[17]\d{8}|\+254\d{9})$/, "Enter a valid phone number", { excludeEmptyString: true })
      .nullable(),
    authorizedSignatoryEmail: yup
      .string()
      .test(
        "is-valid-email",
        "Enter a valid email address",
        function (value) {
          if (!value || value.trim() === "") return true;
          return yup.string().email().isValidSync(value);
        }
      )
      .nullable(),
    contactPersonEmail: yup
      .string()
      .test(
        "is-valid-email",
        "Enter a valid email address",
        function (value) {
          if (!value || value.trim() === "") return true;
          return yup.string().email().isValidSync(value);
        }
      )
      .nullable(),
  });

  const isNonMobile = useMediaQuery("(min-width:600px)");

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      // Destructure values
      const {
        contactNumber,
        email,
        address,
        companyName,
        registrationNumber,
        industrySector,
        contactPersonName,
        contactPersonPosition,
        contactPersonEmail,
        contactPersonPhone,
        companyAddress,
        billingAddress,
        incorporationDate,
        legalStructure,
        countryOfIncorporation,
        taxIdentificationNumber,
        authorizedSignatoryName,
        authorizedSignatoryPosition,
        authorizedSignatoryEmail,
        authorizedSignatoryPhone,
        isActive,
        createdBy,
        updatedBy,
        companyId,
        company,
      } = values;

      const mutationData = props.isEditing
        ? {
            id: props.data.id,
            contactNumber,
            email,
            address,
            companyName,
            registrationNumber,
            industrySector,
            contactPersonName,
            contactPersonPosition,
            contactPersonEmail,
            contactPersonPhone,
            companyAddress,
            billingAddress,
            incorporationDate,
            legalStructure,
            countryOfIncorporation,
            taxIdentificationNumber,
            authorizedSignatoryName,
            authorizedSignatoryPosition,
            authorizedSignatoryEmail,
            authorizedSignatoryPhone,
            isActive: isActive,
            createdBy,
            updatedBy: userId,
            companyId,
            company,
          }
        : {
            contactNumber,
            email,
            address,
            companyName,
            registrationNumber,
            industrySector,
            contactPersonName,
            contactPersonPosition,
            contactPersonEmail,
            contactPersonPhone,
            companyAddress,
            billingAddress,
            incorporationDate,
            legalStructure,
            countryOfIncorporation,
            taxIdentificationNumber,
            authorizedSignatoryName,
            authorizedSignatoryPosition,
            authorizedSignatoryEmail,
            authorizedSignatoryPhone,
            isActive: 1,
            createdBy: userId,
            updatedBy,
            companyId,
            company,
          };

      // Execute mutation

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateCorporateClient" : "createCorporateClient",
        mutationData,
        props.isEditing ? "updatedCorporateClient" : "newCorporateClient",
        base_url
      );
      if (response) {
        props.onClose();

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Client ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        }).then(() => {
          props.refetchData(); // Close the modal after the success message
        });
      }
    } catch (error) {
      // Show error message
      console.error("Mutation error:", error);
             const errorMessage = error.message || "An unexpected error occurred.";
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: errorMessage,
        });
    }

    // Set submitting to false
    setSubmitting(false);
  };

  return (
    <Box m="20px">
      <Header
        title={props.isEditing ? "Edit Client" : "Create Client"}
        subtitle={
          props.isEditing ? "Edit an Existing Client" : "Create a New Client"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                "& > div": {
                  gridColumn: isNonMobile ? undefined : "span 4",
                },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Company Name *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.companyName}
                name="companyName"
                error={touched.companyName && !!errors.companyName}
                helperText={touched.companyName && errors.companyName}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Contact Number *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.contactNumber}
                name="contactNumber"
                error={touched.contactNumber && !!errors.contactNumber}
                helperText={touched.contactNumber && errors.contactNumber}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Email *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.email}
                name="email"
                error={touched.email && !!errors.email}
                helperText={touched.email && errors.email}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Address *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.address}
                name="address"
                error={touched.address && !!errors.address}
                helperText={touched.address && errors.address}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Industry Sector *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.industrySector}
                name="industrySector"
                error={touched.industrySector && !!errors.industrySector}
                helperText={touched.industrySector && errors.industrySector}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Registration Number"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.registrationNumber}
                name="registrationNumber"
                sx={{ gridColumn: "span 2" }}
              />
              {/* <TextField
                fullWidth
                variant="filled"
                type="date"
                label="Incorporation Date"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.incorporationDate}
                name="incorporationDate"
                sx={{ gridColumn: "span 2" }}
                InputLabelProps={{
                  shrink: true,
                }}
              /> */}
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Legal Structure"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.legalStructure}
                name="legalStructure"
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Country of Incorporation"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.countryOfIncorporation}
                name="countryOfIncorporation"
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Tax Identification Number"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.taxIdentificationNumber}
                name="taxIdentificationNumber"
                error={touched.taxIdentificationNumber && !!errors.taxIdentificationNumber}
                helperText={touched.taxIdentificationNumber && errors.taxIdentificationNumber}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Authorized Signatory Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.authorizedSignatoryName}
                name="authorizedSignatoryName"
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Authorized Signatory Position"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.authorizedSignatoryPosition}
                name="authorizedSignatoryPosition"
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Authorized Signatory Email"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.authorizedSignatoryEmail}
                name="authorizedSignatoryEmail"
                error={touched.authorizedSignatoryEmail && !!errors.authorizedSignatoryEmail}
                helperText={touched.authorizedSignatoryEmail && errors.authorizedSignatoryEmail}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Authorized Signatory Phone"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.authorizedSignatoryPhone}
                name="authorizedSignatoryPhone"
                error={touched.authorizedSignatoryPhone && !!errors.authorizedSignatoryPhone}
                helperText={touched.authorizedSignatoryPhone && errors.authorizedSignatoryPhone}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Company Address"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.companyAddress}
                name="companyAddress"
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Billing Address"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.billingAddress}
                name="billingAddress"
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Contact Person Name"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.contactPersonName}
                name="contactPersonName"
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Contact Person Position"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.contactPersonPosition}
                name="contactPersonPosition"
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Contact Person Email"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.contactPersonEmail}
                name="contactPersonEmail"
                error={touched.contactPersonEmail && !!errors.contactPersonEmail}
                helperText={touched.contactPersonEmail && errors.contactPersonEmail}
                sx={{ gridColumn: "span 2" }}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Contact Person Phone"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.contactPersonPhone}
                name="contactPersonPhone"
                error={touched.contactPersonPhone && !!errors.contactPersonPhone}
                helperText={touched.contactPersonPhone && errors.contactPersonPhone}
                sx={{ gridColumn: "span 2" }}
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                variant="contained"
                disabled={isSubmitting}
                startIcon={isSubmitting ? <CircularProgress size={20} /> : null}
                sx={{
                  backgroundColor: '#00A676',
                  color: 'white',
                  '&:hover': {
                    backgroundColor: '#00A676',
                    boxShadow: '0px 4px 12px rgba(0, 166, 118, 0.3)',
                  },
                  '&:disabled': {
                    backgroundColor: '#B0B0B0',
                    color: 'white',
                  },
                }}
              >
                {isSubmitting
                  ? props.isEditing
                    ? "Updating..."
                    : "Saving..."
                  : props.isEditing
                  ? "Update Client"
                  : "Save Client"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default CorporateClientsForm;